import { SurveyQuestionsField } from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/types';
import { QuestionTypeEnum } from '@/types/schema';

import TextEditor from './components/TextEditor';

const TextField: SurveyQuestionsField = {
  type: QuestionTypeEnum.Text,
  Editor: TextEditor,
};

export default TextField;
